import * as React from "react";
import { FC } from "react";
import { Edit, EditProps } from "react-admin";
import { TitleMelCategoryCustomer } from "./Constant/Source";
import MelCategoryCustomerEditForm from "./Forms/MelCategoryCustomerEditForm";

const MelCategoryCustomerEdit: FC<EditProps> = props => {
  return (
    <Edit title={TitleMelCategoryCustomer.edit} component="div" {...props}>
      <MelCategoryCustomerEditForm {...props} />
    </Edit>
  );
};

export default MelCategoryCustomerEdit;
